import { Toaster as Sonner, toast } from "sonner";

/**
 * Spark Scooter branded Sonner toaster.
 * - Dark teal-ink background, yellow accent stripe, mono-eyebrow + display font.
 * - Replaces the generic Sonner / shadcn defaults so notifications look
 *   like part of the app, not a third-party widget.
 */
const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="spark-toaster group"
      visibleToasts={4}
      closeButton
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "spark-toast group relative flex w-full max-w-sm items-start gap-3 rounded-md border border-spark-line bg-spark-ink text-white shadow-2xl px-4 py-3 pr-8 backdrop-blur-md " +
            "before:content-[''] before:absolute before:left-0 before:top-0 before:bottom-0 before:w-1 before:rounded-l-md before:bg-spark-yellow",
          title: "font-display uppercase tracking-wider text-[13px] font-bold leading-snug",
          description: "text-[12px] text-slate-300 leading-snug mt-0.5",
          actionButton:
            "ml-2 rounded-sm bg-spark-yellow px-2.5 py-1 text-[10px] font-display uppercase tracking-wider font-bold text-spark-ink hover:bg-yellow-400",
          cancelButton:
            "ml-2 rounded-sm bg-white/10 px-2.5 py-1 text-[10px] font-display uppercase tracking-wider font-bold text-slate-200 hover:bg-white/15",
          closeButton:
            "absolute top-2 right-2 size-5 rounded-sm flex items-center justify-center text-slate-400 hover:text-white hover:bg-white/10",
          icon: "shrink-0 mt-0.5 text-spark-yellow",
          success: "before:bg-emerald-400",
          error: "before:bg-red-500",
          info: "before:bg-spark-teal",
          warning: "before:bg-orange-400",
          loading: "before:bg-slate-400",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
